import { urlObj } from './appcuesUtilObj';
import { useActivityTracker } from '@nile/components';

export function useAppcuesTrigger(value, name) {
  if (
    window.CommandBar &&
    urlObj[name].conditions.some((condition) => value.includes(condition))
  ) {
    useActivityTracker({
      event: 'Signup',
      data: { source: 'Website new user' }
    });
    window.CommandBar.trackEvent('ExploreSuperops');
    // window.Appcues.show(urlObj[name].flowId);
  }
}

export function checkReferrer(value) {
  return urlObj['referrer'].conditions.some((condition) =>
    value.includes(condition)
  );
}
